// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wrn-","toggle":"styles_toggle__28pCx","preview":"styles_preview__2Kj3_"};